import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import util from '../../util/util'
import { connect } from 'react-redux'
import { Col, message, Row, Spin } from 'antd'
import { Schedule } from '../../component'
import '../../css/schedule.scss'
import { editSchedule, getSchedule } from '../../store/action/schedule.action'
import { useHistory, useLocation, useParams } from 'react-router'
import { setNewPatient } from '../../store/action/patient.action'

var { List } = Schedule

const PatientSchedule = (props) => {
  const params = useParams()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    props.getSchedule(params.id)
    props.setNewPatient(location.state?.patient)
  }, [])

  var handleBack = () => history.push('/patient/' + params.id)

  var handleSave = async () => {
    if(!Array.isArray(props.exercises) || props.exercises.length <= 0) {
      //message.error('Add atleast one exercise2')
      //return;
    }
    // Log the exact payload so a failed save can be debugged from the
    // DevTools console. The action layer fires its own success/error
    // toast based on the server response — don't duplicate it here.
    console.log('[editSchedule] saving exercises:', props.exercises)
    var response = await props.editSchedule(props.patient, props.exercises)
    console.log('[editSchedule] response:', response)
    const ok =
      response &&
      !response.error &&
      typeof response.status === 'string' &&
      response.status.toLowerCase() === 'success'
    if (!ok) return
    history.push('/patient/' + params.id)
  }

  return (
    <Spin spinning={props.isLoading}>
      <Row className='scheduleContainerEdit'>
        <Col className='scheduleContainer' flex={'auto'}>
          <List editPage handleBack={handleBack} handleNext={handleSave} />
        </Col>
      </Row>
    </Spin>
  )
}

PatientSchedule.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading || state.schedule.isLoading,
    customer: state.profile.customer,
    patient: state.patient.newpatient,
    exercises: state.schedule.exercises,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSchedule: (patientid) => dispatch(getSchedule(patientid)),
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
    editSchedule: (patient, exercises) =>
      dispatch(editSchedule({ patient, exercises })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientSchedule)
